import { TrackedEvent, trackEvent } from "@/domains/metrics";
import { useEffectOnMount } from "@/domains/react/useEffectOnMount";
import { electronModule } from "@/modules/electron";
import { observer } from "mobx-react-lite";

export const DesktopAnalyticsBridge = observer(() => {
  useEffectOnMount(() => {
    const onTrackedEvent = ({ trackedEvent }: { trackedEvent: TrackedEvent }) => {
      trackEvent(trackedEvent);
    };

    let unsubscribe: (() => void) | undefined;

    const asyncLogic = async () => {
      try {
        unsubscribe = await electronModule.onTrackedEvent?.({
          callback: onTrackedEvent,
        });
      } catch (_) {
        /* empty */
      }
    };

    void asyncLogic();

    return () => {
      unsubscribe?.();
    };
  });

  return null;
});
